module.exports = __webpack_public_path__ + "src/assets/textures/leaves/lettuce_leaf_opacity_map.jpg";